import React from "react";
import "./styles.css";

export const BrandsAndTestimonials = () => {
  return (
    <section className="brands-section">
      <div className="brands-header">
        <h3>Nuestras marcas</h3>
        <div className="brands-slider">
          <div className="brands-track">
            <img src="./images/marcas/honda.png" alt="Honda" />
            <img src="./images/marcas/bajac.png" alt="Yamaha" />
            <img src="./images/marcas/yamaha.png" alt="Suzuki" />
            <img src="./images/marcas/tvs.png" alt="Bajaj" />
            <img src="./images/marcas/akt.png" alt="AKT" />
            <img src="./images/marcas/hero.png" alt="Victory" />
            <img src="./images/marcas/zuzuki.png" alt="Honda" />
            <img src="./images/marcas/kawasaki.png" alt="Honda" />
            <img src="./images/marcas/ktm.png" alt="Yamaha" />
            <img src="./images/marcas/kymco.png" alt="Suzuki" />
            <img src="./images/marcas/victory.png" alt="Bajaj" />
            <img src="./images/marcas/honda.png" alt="Honda" />
            <img src="./images/marcas/bajac.png" alt="Yamaha" />
            <img src="./images/marcas/yamaha.png" alt="Suzuki" />
            <img src="./images/marcas/tvs.png" alt="Bajaj" />
            <img src="./images/marcas/akt.png" alt="AKT" />
            <img src="./images/marcas/hero.png" alt="Victory" />
            <img src="./images/marcas/zuzuki.png" alt="Honda" />
            <img src="./images/marcas/kawasaki.png" alt="Honda" />
            <img src="./images/marcas/ktm.png" alt="Yamaha" />
            <img src="./images/marcas/kymco.png" alt="Suzuki" />
            <img src="./images/marcas/victory.png" alt="Bajaj" />
            <img src="./images/marcas/honda.png" alt="Honda" />
            <img src="./images/marcas/bajac.png" alt="Yamaha" />
            <img src="./images/marcas/yamaha.png" alt="Suzuki" />
            <img src="./images/marcas/tvs.png" alt="Bajaj" />
            <img src="./images/marcas/akt.png" alt="AKT" />
            <img src="./images/marcas/hero.png" alt="Victory" />
            <img src="./images/marcas/zuzuki.png" alt="Honda" />
            <img src="./images/marcas/kawasaki.png" alt="Honda" />
            <img src="./images/marcas/ktm.png" alt="Yamaha" />
            <img src="./images/marcas/kymco.png" alt="Suzuki" />
            <img src="./images/marcas/victory.png" alt="Bajaj" />
          </div>
        </div>
      </div>
    </section>
  );
};
